import React from "react";
import { Badge, Group, Stack, Text } from "@mantine/core";
import moment from "moment";

const idOf = (value) => {
  if (value == null || value === "") return "";
  if (typeof value === "object") return String(value._id || "");
  return String(value);
};

const personLabel = (person) => {
  if (!person || typeof person !== "object") return "";
  const staff = person.staffId ? `[${person.staffId}] ` : "";
  const name = person.name || person.cname || "";
  return `${staff}${name}`.trim();
};

const OrderUplineAckList = ({ form }) => {
  const rows = form?.values?.uplineAcks;
  if (!Array.isArray(rows) || rows.length === 0) return null;

  const orderConsultants = Array.isArray(form?.values?.consultants)
    ? form.values.consultants
    : [];
  const consultantById = new Map(
    orderConsultants.map((consultant) => [idOf(consultant), consultant]),
  );

  const resolvePeople = (people = []) =>
    people
      .map((person) => {
        if (person && typeof person === "object" && (person.name || person.cname)) {
          return person;
        }
        return consultantById.get(idOf(person)) || null;
      })
      .filter(Boolean);

  return (
    <Stack spacing="sm" mt="md">
      <Text size="sm" weight={600}>
        Upline acknowledgement
      </Text>
      {rows.map((row, index) => {
        const acknowledged = Boolean(row?.acknowledgedAt);
        const upline = resolvePeople([row?.upline])[0];
        const consultants = resolvePeople(row?.consultants);
        const key = idOf(row?.upline) || index;
        return (
          <Stack key={String(key)} spacing={4}>
            <div>
              <Text size="xs" color="dimmed">
                Upline
              </Text>
              <Text size="sm">{personLabel(upline) || "—"}</Text>
            </div>
            <Text size="xs" color="dimmed">
              Consultants:{" "}
              {consultants.map(personLabel).filter(Boolean).join(", ") || "—"}
            </Text>
            <Group>
              {acknowledged ? (
                <Badge color="green" variant="light" size="sm">
                  Acknowledged{" "}
                  {moment(row.acknowledgedAt).format("YYYY-MM-DD HH:mm")}
                </Badge>
              ) : (
                <Badge color="yellow" variant="light" size="sm">
                  Pending
                  {row?.notifiedAt
                    ? ` since ${moment(row.notifiedAt).format("YYYY-MM-DD HH:mm")}`
                    : ""}
                </Badge>
              )}
            </Group>
          </Stack>
        );
      })}
    </Stack>
  );
};

export default OrderUplineAckList;
